/// <reference path="../../app.ts" />
namespace Cfnc {
    "use strict";

    interface ICalendarModalScope extends ng.IScope {

        schoolid: any;
        uiConfig: any;
        eventSources: any[];
        vm: any;
        eventRender: any;
        eventWell: any;
        toggleLock: boolean;
        
        close: () => void;
        setEventWell: (id: string, eventName: string, category: string, startDate: string, endDate: string, isAllDay: string, description: string) => void;
        clearEventWell: () => void;
        lockWell: () => void;
    }

    interface ICalendarModal {
    }

    class CalendarModal implements ICalendarModal {
        static controllerId: string = "calendarModal";
        uiConfig: any;
        private log;
        eventSources: any[];
        locked: boolean;
        
        eventWell: EventDetails;
        lockedWell: EventDetails;

        static $inject: string[] = ["$window", "$uibModalInstance", "$scope", "$filter", "common", "config", "Restangular", "schoolid", "uiCalendarConfig", "$compile"];

        constructor(
            private $window: ng.IWindowService,
            private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            private $scope: ICalendarModalScope,
            private $filter: ng.IFilterService,
            private common: ICommonFactory,
            private config: IConfig,
            private Restangular: Restangular.IService,
            schoolid: string,
            private uiCalendarConfig,
            private $compile: ng.ICompileService) {
            
            this.locked = false;
            var date = new Date();
            var d = date.getDate();
            var m = date.getMonth();
            var y = date.getFullYear();
            this.$scope.eventRender = this.eventRender;

            this.uiConfig = {
                calendar: {
                    editable: false,
                    header: {
                        left: "prev,next",
                        center: "title",
                        right: "month,agendaWeek,agendaDay"
                    },
                    timezone: "local",
                    eventRender: this.$scope.eventRender,
                }
            };

            this.log = common.logger.getLogFn(CalendarModal.controllerId);
            $scope.close = this.close;
            $scope.setEventWell = this.setEventWell;
            $scope.clearEventWell = this.clearEventWell;
            $scope.lockWell = this.lockWell;
            $scope.eventWell = this.eventWell;
            $scope.uiConfig = this.uiConfig;
            $scope.schoolid = schoolid;
            $scope.eventSources = [this.getEvents];
            $scope.vm = {
                uiConfig: this.uiConfig,
                eventSources: [this.getEvents],
                eventWell: {}
            };
            this.activate();
        }

        activate = () => {
            this.common.activateController([], "calendar")
                .then(result => {
                    this.log("Activated Calendar View");
                });
        };

        getEvents = (start, end, timezone, callback): void => {
            if (!start || !end) {
                return;
            }

            var queryParams = {
                organizationId: this.$scope.schoolid,
                beginDate: moment(start).toISOString(),
                endDate: moment(end).toISOString()
            };


            this.Restangular.all("Calendar/getCalendarEvents").getList(queryParams).then((result: any) => {
                callback(_.map(result, this.mapToFullCalendar));
                return result.results;
            }, (reason) => {
                this.log(reason);
            });
        };

        mapToFullCalendar = (event: any): any => {

            return {
                id: event.id,
                title: event.name,
                category: event.category,
                start: event.start,
                end: event.end,
                allDay: event.allDayEvent,
                desc: event.description
            };
        };

        eventRender = (event, element) => {

            var eventStart = event.start === null ? event.start : event.start._i;
            var eventEnd = event.end === null ? event.end : event.end._i;
            var eventDesc = event.desc === null ? event.desc : event.desc.replace("'", "&#39;");

            var setEventWellCall: string = "setEventWell('"
                + event.id + "', '"
                + event.title.replace("'", "&#39;") + "', '"
                + event.category + "', '" + eventStart + "', '"
                + eventEnd + "', '"
                + event.allDay + "', '"
                + eventDesc
                + "' )";

            element.attr({
                "ng-mouseover": setEventWellCall,
                "ng-focus": setEventWellCall,
                "ng-mouseleave": "clearEventWell()",
                "ng-blur": "clearEventWell()",
                "ng-click": "lockWell()",
                "href": ""
            });
            this.$compile(element)(this.$scope);
        };

        close = () => {
            this.$uibModalInstance.close();
        }

        setEventWell(id: string, eventName: string, category: string, startDate: string, endDate: string, isAllDay: string, description: string) {
            if (this.eventWell == null || this.eventWell.id !== id) {
                
                if (this.locked)
                    this.lockedWell = this.eventWell;

                var setEndDate = endDate != "null" ? new Date(endDate) : null;

                this.eventWell = {
                    id: id,
                    schoolName: "",
                    userId: "",
                    applicationDefinitionId: "",
                    name: eventName.replace("&#39;", "'"),
                    category: category,
                    start: new Date(startDate),
                    end: setEndDate,
                    allDayEvent: (isAllDay === "true"),
                    description: description.replace("&#39;", "'")
                }
            }
        }

        lockWell() {
            this.lockedWell = this.eventWell;
            this.locked = !this.locked;
        }

        clearEventWell() {
            if (!this.locked)
                this.eventWell = null;
            else
                this.eventWell = this.lockedWell
        }
    }


    angular.module("app").controller(CalendarModal.controllerId, CalendarModal);
} 